import { DEFAULT_AVATAR_RES } from '@atlassian/jira-business-constants/src/index.tsx';
import { REPORTER_TYPE, ASSIGNEE_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { DataTransformFn } from '../../../bulk-edit-transform/types.tsx';
import type {
	jiraSingleUserFieldFragment_user as JiraSingleUser,
	jiraSingleUserFieldFragment as SingleSelectUserPickerField,
} from '../fragment/__generated_apollo__/jiraSingleUserFieldFragment.ts';
import type { AssigneeFormData, UserFormData } from './types.tsx';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const activeAccountStatus = 'active' as JiraSingleUser['accountStatus'];

export const transformAssigneeFieldForOptimisticUpdates: DataTransformFn<
	SingleSelectUserPickerField,
	AssigneeFormData
> = (
	existingField: SingleSelectUserPickerField,
	fieldData: AssigneeFormData,
): SingleSelectUserPickerField => ({
	...existingField,
	user:
		fieldData != null
			? {
					accountId: fieldData.accountId ?? '',
					accountStatus: activeAccountStatus,
					picture: fieldData.avatarUrls[DEFAULT_AVATAR_RES],
					name: fieldData.displayName,
					__typename: 'AtlassianAccountUser',
				}
			: null,
});

export const transformUserFieldForOptimisticUpdates: DataTransformFn<
	SingleSelectUserPickerField,
	UserFormData
> = (
	existingField: SingleSelectUserPickerField,
	fieldData: UserFormData,
): SingleSelectUserPickerField => ({
	...existingField,
	user:
		fieldData != null
			? {
					accountId: fieldData.id ?? '',
					accountStatus: activeAccountStatus,
					picture: fieldData.avatarUrl,
					name: fieldData.name,
					__typename: 'AtlassianAccountUser',
				}
			: null,
});

export const userOptimisticUpdatesHandler: {
	[key: string]:
		| DataTransformFn<SingleSelectUserPickerField, AssigneeFormData>
		| DataTransformFn<SingleSelectUserPickerField, UserFormData>;
} = {
	[REPORTER_TYPE]: transformUserFieldForOptimisticUpdates,
	[ASSIGNEE_TYPE]: transformAssigneeFieldForOptimisticUpdates,
};
